/* global angular, moment */
(function () {
  'use strict';
  angular.module('vcfinance.cart')
    .component('cartcounter', {
      restrict: 'E',
      bindings: {
        clientid: '<'
      },
      template: `
        <span class="badge badge-info"  
              uib-tooltip="Anzahl der unterschiedlichen Leistungen/Waren im Warenkorb, Gesamtzahl der Leistungen/Waren"  
              tooltip-placement="auto">{{vm.counter}}/{{vm.total}}</span>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Cart', 'Rlog', 'vertxEventBusService', '$http',
        function ($log, Cart, Rlog, vertxEventBusService, $http) {
          let vm = this;


          // vm.clientid might be late propagating, get exams on first change
          vm.$onChanges = function (changes) {
            // if (!changes.isFirstChange) {
            if (angular.isDefined(changes.clientid) && angular.isDefined(changes.clientid.currentValue)) {
              vm.clientid = changes.clientid.currentValue;
              if (angular.isDefined(vm.clientid)) {
                getCounter();
              }
            }
            // }
          };

          function getCounter() {

            Cart.getCount(vm.clientid).then(res => {
              vm.counter = 0;
              vm.total = 0;
              // $log.debug('**** cart Counter data: ', res.data );
                vm.counter = res.data.count;
                vm.total = res.data.total;
            }, err => {
              Rlog.error('vcfinance.cart', 'cartcounter', 'counter aqusistion  failed', {});
            });
          }


          // listen for files updates
          vertxEventBusService.on('carts.update', function (message) {
            // $log.debug('cartcounter update caught');
            getCounter();
          });
        }
      ] // controller
    }); // component

// klammerfriedhof
}());